// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__36qhQ","header":"ReportDetails_header__3ZQfd","title":"ReportDetails_title__1d4-k","left":"ReportDetails_left__f53Ld"};